import { Pipe, PipeTransform } from '@angular/core';
import { RequirementDto } from 'src/app/shared/models/job-unit-requirements.model';

@Pipe({
    name: 'extractCertificationTitles',
    standalone: true
})
export class ExtractCertificationTitlesPipe implements PipeTransform {
    transform(certifications: RequirementDto[]): string | null {
        if (!certifications || certifications.length === 0) {
            return '-';
        }

        return certifications
            .map((item) => {
                if (item && !item.isNA) {
                    let title = item.name;
                    if (item.isPreferred) {
                        title += '*';
                    }
                    return title;
                } else {
                    return null;
                }
            })
            .filter((x) => x)
            .sort((a, b) => a.localeCompare(b))
            .join(', ');
    }
}
